export const FETCH_POSTS = 'FETCH_POSTS';
export const SEARCH_POSTS = 'SEARCH_POSTS';
export const IS_LOADING_CHANGE_STATE = 'IS_LOADING_CHANGE_STATE';
export const POSTS_FOUND_CHANGE_STATE = 'FOUND_POSTS_CHANGE_STATE';
export const POSTS_NOT_FOUND_CHANGE_STATE = 'POSTS_NOT_FOUND_CHANGE_STATE';